import { EntitiesState } from '../entities'
import * as ModuleStates from './types'
import { ModuleState } from './types'

// START MODULE IMPORTS
import * as activities from './activity'
import * as adCopies from './adCopy'
import * as addresses from './address'
import * as agencies from './agency'
import * as agencyContacts from './agencyContact'
import * as agencyOrderBundles from './agencyOrderBundle'
import * as agencyPaymentMethods from './agencyPaymentMethod'
import * as agencyPortals from './agencyPortal'
import * as agencyProviderDeadlineGroups from './agencyProviderDeadlineGroup'
import * as agencyProviderPackages from './agencyProviderPackage'
import * as agencyProviderPriceOverrides from './agencyProviderPriceOverride'
import * as agencyProviders from './agencyProvider'
import * as agencyPublications from './agencyPublication'
import * as agencyTags from './agencyTag'
import * as agents from './agent'
import * as apiKeys from './apiKey'
import * as apiLogs from './apiLog'
import * as artworkPages from './artworkPage'
import * as artworkReviews from './artworkReview'
import * as artworks from './artwork'
import * as assetLibraries from './assetLibrary'
import * as attachments from './attachment'
import * as auditLogs from './auditLog'
import * as billingTypes from './billingType'
import * as brandColours from './brandColour'
import * as brandCustomProfiles from './brandCustomProfile'
import * as brandGroupMembers from './brandGroupMember'
import * as brandGroupProviders from './brandGroupProvider'
import * as brandGroupPublications from './brandGroupPublication'
import * as brandGroups from './brandGroup'
import * as brandProviders from './brandProvider'
import * as brandThemes from './brandTheme'
import * as brands from './brand'
import * as campaignCategories from './campaignCategory'
import * as campaignCommercialCategories from './campaignCommercialCategory'
import * as campaignComparables from './campaignComparable'
import * as campaignContacts from './campaignContact'
import * as campaignContributions from './campaignContribution'
import * as campaignDocuments from './campaignDocument'
import * as campaignInspections from './campaignInspection'
import * as campaignItems from './campaignItem'
import * as campaignPortalSyncs from './campaignPortalSync'
import * as campaignPortals from './campaignPortal'
import * as campaignQuoteItems from './campaignQuoteItem'
import * as campaignQuoteSections from './campaignQuoteSection'
import * as campaignQuoteTemplateItems from './campaignQuoteTemplateItem'
import * as campaignQuoteTemplateSections from './campaignQuoteTemplateSection'
import * as campaignQuoteTemplates from './campaignQuoteTemplate'
import * as campaignQuotes from './campaignQuote'
import * as campaignRuralCategories from './campaignRuralCategory'
import * as campaignSaleMethods from './campaignSaleMethod'
import * as campaignStatuses from './campaignStatus'
import * as campaignTypes from './campaignType'
import * as campaigns from './campaign'
import * as charts from './chart'
import * as comments from './comment'
import * as contacts from './contact'
import * as contracts from './contract'
import * as conversations from './conversation'
import * as creditNoteItems from './creditNoteItem'
import * as creditNotes from './creditNote'
import * as currentUser from './currentUser'
import * as customDeadlines from './customDeadline'
import * as customFieldSets from './customFieldSet'
import * as customFields from './customField'
import * as customItemGroups from './customItemGroup'
import * as customItems from './customItem'
import * as customShortcodes from './customShortcode'
import * as dataStoreItems from './dataStoreItem'
import * as defaultQuoteItems from './defaultQuoteItem'
import * as entities from '../entities'
import * as favouriteOrderItems from './favouriteOrderItem'
import * as favouriteOrders from './favouriteOrder'
import * as financeApplications from './financeApplication'
import * as flipperSettings from './flipperSetting'
import * as fontFamilies from './fontFamily'
import * as fonts from './font'
import * as geoCountries from './geoCountry'
import * as geoStates from './geoState'
import * as geoSuburbs from './geoSuburb'
import * as imageLibraries from './imageLibrary'
import * as images from './image'
import * as integrations from './integration'
import * as invoiceItems from './invoiceItem'
import * as invoices from './invoice'
import * as layoutTemplates from './layoutTemplate'
import * as loginSessions from './loginSession'
import * as mediaLinks from './mediaLink'
import * as navigation from './navigation'
import * as notifications from './notification'
import * as orderBundleItems from './orderBundleItem'
import * as orderBundles from './orderBundle'
import * as orderItemTaskTypes from './orderItemTaskType'
import * as orderItemTasks from './orderItemTask'
import * as orderItems from './orderItem'
import * as orderLeadTimes from './orderLeadTime'
import * as orders from './order'
import * as paginationRules from './paginationRule'
import * as paymentMethods from './paymentMethod'
import * as portalOptionValues from './portalOptionValue'
import * as portalOptions from './portalOption'
import * as portals from './portal'
import * as pricingPlans from './pricingPlan'
import * as priorityCampaigns from './priorityCampaign'
import * as processingFees from './processingFee'
import * as providerAccounts from './providerAccount'
import * as providerDeadlineGroups from './providerDeadlineGroup'
import * as providerDisclaimers from './providerDisclaimer'
import * as providerOrderCodes from './providerOrderCode'
import * as providerPackageItems from './providerPackageItem'
import * as providerPackages from './providerPackage'
import * as providerPriceListItemOptionValues from './providerPriceListItemOptionValue'
import * as providerPriceListItemOptions from './providerPriceListItemOption'
import * as providerPriceListItems from './providerPriceListItem'
import * as providerPriceListProductUnlocks from './providerPriceListProductUnlock'
import * as providerPriceLists from './providerPriceList'
import * as providerProductCodes from './providerProductCode'
import * as providerServices from './providerService'
import * as providers from './provider'
import * as publicationBookingItems from './publicationBookingItem'
import * as publicationBookings from './publicationBooking'
import * as publicationCompatiblePaginations from './publicationCompatiblePagination'
import * as publicationEditionDeadlines from './publicationEditionDeadline'
import * as publicationEditions from './publicationEdition'
import * as publicationInspections from './publicationInspection'
import * as publicationOptionValues from './publicationOptionValue'
import * as publicationOptions from './publicationOption'
import * as publicationOrders from './publicationOrder'
import * as publicationPaginationRules from './publicationPaginationRule'
import * as publicationProducts from './publicationProduct'
import * as publicationSpecialDeadlines from './publicationSpecialDeadline'
import * as publications from './publication'
import * as roles from './role'
import * as savedArtworkPages from './savedArtworkPage'
import * as savedArtworks from './savedArtwork'
import * as serviceCategories from './serviceCategory'
import * as serviceProducts from './serviceProduct'
import * as services from './service'
import * as smsLogs from './smsLog'
import * as statuses from './status'
import * as subscribers from './subscriber'
import * as systems from './system'
import * as tags from './tag'
import * as teamMembers from './teamMember'
import * as teams from './team'
import * as templatePageCategories from './templatePageCategory'
import * as templatePages from './templatePage'
import * as trackingLinks from './trackingLink'
import * as trainingCourses from './trainingCourse'
import * as trainingLessons from './trainingLesson'
import * as trainingModules from './trainingModule'
import * as users from './user'
import * as webhooks from './webhook'
// END MODULE IMPORTS

export type RootReducerState = {
// START ROOT REDUCER STATE
  activities: ModuleStates.ActivityModuleState,
  adCopies: ModuleStates.AdCopyModuleState,
  addresses: ModuleStates.AddressModuleState,
  agencies: ModuleStates.AgencyModuleState,
  agencyContacts: ModuleStates.AgencyContactModuleState,
  agencyOrderBundles: ModuleStates.AgencyOrderBundleModuleState,
  agencyPaymentMethods: ModuleStates.AgencyPaymentMethodModuleState,
  agencyPortals: ModuleStates.AgencyPortalModuleState,
  agencyProviderDeadlineGroups: ModuleStates.AgencyProviderDeadlineGroupModuleState,
  agencyProviderPackages: ModuleStates.AgencyProviderPackageModuleState,
  agencyProviderPriceOverrides: ModuleStates.AgencyProviderPriceOverrideModuleState,
  agencyProviders: ModuleStates.AgencyProviderModuleState,
  agencyPublications: ModuleStates.AgencyPublicationModuleState,
  agencyTags: ModuleStates.AgencyTagModuleState,
  agents: ModuleStates.AgentModuleState,
  apiKeys: ModuleStates.ApiKeyModuleState,
  apiLogs: ModuleStates.ApiLogModuleState,
  artworkPages: ModuleStates.ArtworkPageModuleState,
  artworkReviews: ModuleStates.ArtworkReviewModuleState,
  artworks: ModuleStates.ArtworkModuleState,
  assetLibraries: ModuleStates.AssetLibraryModuleState,
  attachments: ModuleStates.AttachmentModuleState,
  auditLogs: ModuleStates.AuditLogModuleState,
  billingTypes: ModuleStates.BillingTypeModuleState,
  brandColours: ModuleStates.BrandColourModuleState,
  brandCustomProfiles: ModuleStates.BrandCustomProfileModuleState,
  brandGroupMembers: ModuleStates.BrandGroupMemberModuleState,
  brandGroupProviders: ModuleStates.BrandGroupProviderModuleState,
  brandGroupPublications: ModuleStates.BrandGroupPublicationModuleState,
  brandGroups: ModuleStates.BrandGroupModuleState,
  brandProviders: ModuleStates.BrandProviderModuleState,
  brandThemes: ModuleStates.BrandThemeModulestate,
  brands: ModuleStates.BrandModuleState,
  campaignCategories: ModuleStates.CampaignCategoryModuleState,
  campaignCommercialCategories: ModuleStates.CampaignCommercialCategoryModuleState,
  campaignComparables: ModuleStates.CampaignComparableModuleState,
  campaignContacts: ModuleStates.CampaignContactModuleState,
  campaignContributions: ModuleStates.CampaignContributionModuleState,
  campaignDocuments: ModuleStates.CampaignDocumentModuleState,
  campaignInspections: ModuleStates.CampaignInspectionModuleState,
  campaignItems: ModuleStates.CampaignItemModuleState,
  campaignPortalSyncs: ModuleStates.CampaignPortalSyncModuleState,
  campaignPortals: ModuleStates.CampaignPortalModuleState,
  campaignQuoteItems: ModuleStates.CampaignQuoteItemModuleState,
  campaignQuoteSections: ModuleStates.CampaignQuoteSectionModuleState,
  campaignQuoteTemplateItems: ModuleStates.CampaignQuoteTemplateItemModuleState,
  campaignQuoteTemplateSections: ModuleStates.CampaignQuoteTemplateSectionModuleState,
  campaignQuoteTemplates: ModuleStates.CampaignQuoteTemplateModuleState,
  campaignQuotes: ModuleStates.CampaignQuoteModuleState,
  campaignRuralCategories: ModuleStates.CampaignRuralCategoryModuleState,
  campaignSaleMethods: ModuleStates.CampaignSaleMethodModuleState,
  campaignStatuses: ModuleStates.CampaignStatusModuleState,
  campaignTypes: ModuleStates.CampaignTypeModuleState,
  campaigns: ModuleStates.CampaignModuleState,
  charts: ModuleStates.ChartModuleState,
  comments: ModuleStates.CommentModuleState,
  contacts: ModuleStates.ContactModuleState,
  contracts: ModuleState,
  conversations: ModuleStates.ConversationModuleState,
  creditNoteItems: ModuleStates.CreditNoteItemModuleState,
  creditNotes: ModuleStates.CreditNoteModuleState,
  currentUser: ModuleState,
  customDeadlines: ModuleStates.CustomDeadlineModuleState,
  customFieldSets: ModuleState,
  customFields: ModuleStates.CustomFieldModuleState,
  customItemGroups: ModuleStates.CustomItemGroupModuleState,
  customItems: ModuleStates.CustomItemModuleState,
  customShortcodes: ModuleState,
  dataStoreItems: ModuleStates.DataStoreItemModuleState,
  defaultQuoteItems: ModuleStates.DefaultQuoteItemModuleState,
  entities: EntitiesState,
  favouriteOrderItems: ModuleStates.FavouriteOrderItemModuleState,
  favouriteOrders: ModuleStates.FavouriteOrderModuleState,
  financeApplications: ModuleStates.FinanceApplicationModuleState,
  flipperSettings: ModuleStates.FlipperSettingModuleState,
  fontFamilies: ModuleState,
  fonts: ModuleState,
  geoCountries: ModuleStates.GeoCountryModuleState,
  geoStates: ModuleStates.GeoStateModuleState,
  geoSuburbs: ModuleStates.GeoSuburbModuleState,
  imageLibraries: ModuleStates.ImageLibraryModuleState,
  images: ModuleStates.ImageModuleState,
  integrations: ModuleStates.IntegrationModuleState,
  invoiceItems: ModuleStates.InvoiceItemModuleState,
  invoices: ModuleStates.InvoiceModuleState,
  layoutTemplates: ModuleStates.LayoutTemplateModuleState,
  loginSessions: ModuleStates.LoginSessionModuleState,
  mediaLinks: ModuleStates.MediaLinkModuleState,
  navigation: { showNavigation: boolean },
  notifications: ModuleStates.NotificationModuleState,
  orderBundleItems: ModuleStates.OrderBundleItemModuleState,
  orderBundles: ModuleStates.OrderBundleModuleState,
  orderItemTaskTypes: ModuleState,
  orderItemTasks: ModuleStates.OrderItemTaskModuleState,
  orderItems: ModuleStates.OrderBundleItemModuleState,
  orderLeadTimes: ModuleState,
  orders: ModuleStates.OrderModuleState,
  paginationRules: ModuleStates.PaginationRuleModuleState,
  paymentMethods: ModuleStates.PaymentMethodModuleState,
  portalOptionValues: ModuleStates.PortalOptionValueModuleState,
  portalOptions: ModuleStates.PortalOptionModuleState,
  portals: ModuleStates.PortalModuleState,
  pricingPlans: ModuleStates.PricingPlanModuleState,
  priorityCampaigns: ModuleStates.PriorityCampaignModuleState,
  processingFees: ModuleStates.ProcessingFeeModuleState,
  providerAccounts: ModuleStates.ProviderAccountModuleState,
  providerDeadlineGroups: ModuleState,
  providerDisclaimers: ModuleState,
  providerOrderCodes: ModuleState,
  providerPackageItems: ModuleStates.ProviderPackageItemModuleState,
  providerPackages: ModuleStates.ProviderPackageModuleState,
  providerPriceListItemOptionValues: ModuleStates.ProviderPriceListItemOptionValueModuleState,
  providerPriceListItemOptions: ModuleStates.ProviderPriceListItemOptionModuleState,
  providerPriceListItems: ModuleStates.ProviderPriceListItemModuleState,
  providerPriceListProductUnlocks: ModuleStates.ProviderPriceListProductUnlockModuleState,
  providerPriceLists: ModuleStates.ProviderPriceListModuleState,
  providerProductCodes: ModuleState,
  providerServices: ModuleState,
  providers: ModuleState,
  publicationBookingItems: ModuleStates.PublicationBookingItemModuleState,
  publicationBookings: ModuleStates.PublicationBookingModuleState,
  publicationCompatiblePaginations: ModuleState,
  publicationEditionDeadlines: ModuleStates.PublicationEditionDeadlineModuleState,
  publicationEditions: ModuleStates.PublicationEditionModuleState,
  publicationInspections: ModuleStates.PublicationPaginationRuleModuleState,
  publicationOptionValues: ModuleState,
  publicationOptions: ModuleState,
  publicationOrders: ModuleStates.PublicationOrderModuleState,
  publicationPaginationRules: ModuleStates.PublicationPaginationRuleModuleState,
  publicationProducts: ModuleState,
  publicationSpecialDeadlines: ModuleState,
  publications: ModuleState,
  roles: ModuleState,
  savedArtworkPages: ModuleStates.SavedArtworkPageModuleState,
  savedArtworks: ModuleStates.SavedArtworkModuleState,
  serviceCategories: ModuleStates.ServiceCategoryModuleState,
  serviceProducts: ModuleState,
  services: ModuleStates.ServiceModuleState,
  smsLogs: ModuleStates.SmsLogModuleState,
  statuses: ModuleStates.StatusModuleState,
  subscribers: ModuleStates.SubscriberModuleState,
  systems: ModuleStates.SystemModuleState,
  tags: ModuleStates.TagModuleState,
  teamMembers: ModuleStates.TeamMemberModuleState,
  teams: ModuleStates.TeamModuleState,
  templatePageCategories: ModuleStates.TemplatePageCategoryModuleState,
  templatePages: ModuleStates.TemplatePageModuleState,
  trackingLinks: ModuleStates.TrackingLinkModuleState,
  trainingCourses: ModuleStates.TrainingCourseModuleState,
  trainingLessons: ModuleStates.TrainingLessonModuleState,
  trainingModules: ModuleStates.TrainingModuleModuleState,
  users: ModuleState,
  webhooks: ModuleStates.WebhookModuleState,
// END ROOT REDUCER STATE
}

const modules = {
// START MODULES LIST
  activities,
  adCopies,
  addresses,
  agencies,
  agencyContacts,
  agencyOrderBundles,
  agencyPaymentMethods,
  agencyPortals,
  agencyProviderDeadlineGroups,
  agencyProviderPackages,
  agencyProviderPriceOverrides,
  agencyProviders,
  agencyPublications,
  agencyTags,
  agents,
  apiKeys,
  apiLogs,
  artworkPages,
  artworkReviews,
  artworks,
  assetLibraries,
  attachments,
  auditLogs,
  billingTypes,
  brandColours,
  brandCustomProfiles,
  brandGroupMembers,
  brandGroupProviders,
  brandGroupPublications,
  brandGroups,
  brandProviders,
  brandThemes,
  brands,
  campaignCategories,
  campaignCommercialCategories,
  campaignComparables,
  campaignContacts,
  campaignContributions,
  campaignDocuments,
  campaignInspections,
  campaignItems,
  campaignPortalSyncs,
  campaignPortals,
  campaignQuoteItems,
  campaignQuoteSections,
  campaignQuoteTemplateItems,
  campaignQuoteTemplateSections,
  campaignQuoteTemplates,
  campaignQuotes,
  campaignRuralCategories,
  campaignSaleMethods,
  campaignStatuses,
  campaignTypes,
  campaigns,
  charts,
  comments,
  contacts,
  contracts,
  conversations,
  creditNoteItems,
  creditNotes,
  currentUser,
  customDeadlines,
  customFieldSets,
  customFields,
  customItemGroups,
  customItems,
  customShortcodes,
  dataStoreItems,
  defaultQuoteItems,
  entities,
  favouriteOrderItems,
  favouriteOrders,
  flipperSettings,
  financeApplications,
  fontFamilies,
  fonts,
  geoCountries,
  geoStates,
  geoSuburbs,
  imageLibraries,
  images,
  integrations,
  invoiceItems,
  invoices,
  layoutTemplates,
  loginSessions,
  mediaLinks,
  navigation,
  notifications,
  orderBundleItems,
  orderBundles,
  orderItemTaskTypes,
  orderItemTasks,
  orderItems,
  orderLeadTimes,
  orders,
  paginationRules,
  paymentMethods,
  portalOptionValues,
  portalOptions,
  portals,
  pricingPlans,
  priorityCampaigns,
  processingFees,
  providerAccounts,
  providerDeadlineGroups,
  providerDisclaimers,
  providerOrderCodes,
  providerPackageItems,
  providerPackages,
  providerPriceListItemOptionValues,
  providerPriceListItemOptions,
  providerPriceListItems,
  providerPriceListProductUnlocks,
  providerPriceLists,
  providerProductCodes,
  providerServices,
  providers,
  publicationBookingItems,
  publicationBookings,
  publicationCompatiblePaginations,
  publicationEditionDeadlines,
  publicationEditions,
  publicationInspections,
  publicationOptionValues,
  publicationOptions,
  publicationOrders,
  publicationPaginationRules,
  publicationProducts,
  publicationSpecialDeadlines,
  publications,
  roles,
  savedArtworkPages,
  savedArtworks,
  serviceCategories,
  serviceProducts,
  services,
  smsLogs,
  statuses,
  subscribers,
  systems,
  tags,
  teamMembers,
  teams,
  templatePageCategories,
  templatePages,
  trackingLinks,
  trainingCourses,
  trainingLessons,
  trainingModules,
  users,
  webhooks,
// END MODULES LIST
}

export const reducers = Object.keys(modules).reduce((acc, moduleKey) => {
  // @ts-expect-error TS7053
  const module = modules[moduleKey]
  // @ts-expect-error TS7053
  acc[moduleKey] = module.default

  return acc
}, {})

export default modules
